/* eslint-disable */

import { createRouter, createWebHistory } from 'vue-router'
import { Auth } from '@aws-amplify/auth'
import store from '@/store'
import { getUserByEmail } from '@/plugins/authUtils'
import { i18n } from '../plugins/i18n'

const CabinetLogin = () => import('../pages/login/Login')
const CabinetLoginIBportal = () => import('../pages/ibPortal/LoginIBportal.vue')
const CabinetRegister = () => import('../pages/login/Register')
const CabinetRegisterIBportal = () => import('../pages/ibPortal/registerIBportal')
const CabinetForgotPassword = () => import('../pages/login/ForgotPassword')
const CabinetResetPassword = () => import('../pages/login/ResetPassoword.vue')
const Default = () => import('../layouts/cabinet/Default')
const CabinetConsole = () => import('../pages/cabinet/Console')
const CabinetAccounts = () => import('../pages/cabinet/Accounts/Accounts.vue')
const CabinetPlatforms = () =>
	import('../pages/cabinet/Platforms/Platforms.vue')
const CabinetHistory = () => import('../pages/cabinet/History/History.vue')
const CabinetTradingTools = () =>
	import('../pages/cabinet/TradingTools/TradingTools.vue')
const CabinetDeposit = () => import('../pages/cabinet/Deposit')
const CabinetTransfer = () => import('../pages/cabinet/Transfer')
const CabinetWithdraw = () => import('../pages/cabinet/Withdraw')

const CabinetExpiredDocuments = () =>
	import('../pages/cabinet/ExpiredDocuments/ExpiredDocuments.vue')

const CabinetPassword = () => import('../pages/cabinet/Settings/Password.vue')
const CabinetContactUs = () =>
	import('../pages/cabinet/ContactUs/ContactUs.vue')
const SuccessPage = () => import('../pages/cabinet/SuccessPage')
const RejectionPage = () => import('../pages/cabinet/RejectionPage')
const InfoPage = () => import('../pages/cabinet/InfoPage')
const ApplicationProcess = () =>
	import('../pages/cabinet/App/ApplicationProcess.vue')
const Wellcome = () => import('../pages/cabinet/Wellcome')
const NewDemoAccount = () =>
	import('../components/accounts_new/molecules/NewDemoAccount.vue')

let use_email = ''
async function requireAuth(to, from, next) {
	await Auth.currentAuthenticatedUser()
		.then((data) => {
			use_email = data.attributes.email

			next()
		})
		.catch((e) => {
			next({
				path: `/${i18n.global.locale}/login`,
			})
		})
}

const router = createRouter({
	mode: 'history',
	base: '/',
	history: createWebHistory(),
	linkActiveClass: 'open active',
	scrollBehavior: () => ({ y: 0 }),
	routes: [
		{
			path: '/',
			redirect: `/${i18n.global.locale}/login`,
		},
		{
			path: '/login',
			redirect: `/${i18n.global.locale}/login`,
		},
		{
			path: '/:locale',
			children: [
				{
					path: 'register',
					redirect: '/register/1/live-account',
				},
				{
					path: 'register/:id/:account',
					name: 'Register',
					component: CabinetRegister,
				},
				{
					path: 'register_ib_portal/:id/:account',
					name: 'RegisterIBportal',
					component: CabinetRegisterIBportal,
				},
				{
					path: 'login',
					name: 'Login',
					component: CabinetLogin,
				},
				{
					path: 'login_ib_portal',
					name: 'LoginIBportal',
					component: CabinetLoginIBportal,
				},
				{
					path: 'reset-password',
					name: 'ResetPassword',
					component: CabinetResetPassword,
				},
				{
					path: 'forgot',
					name: 'Forgot',
					component: CabinetForgotPassword,
				},
				{
					path: 'cabinet',
					name: 'Cabinet',
					component: Default,
					children: [
						{
							path: 'console',
							name: 'Console',
							component: CabinetConsole,
							children: [
								{
									path: 'welcome',
									name: 'Welcome',
									component: Wellcome,
									beforeEnter: requireAuth,
								},
								{
									path: 'accounts',
									name: 'Accounts',
									component: CabinetAccounts,
									beforeEnter: requireAuth,
								},
								{
									path: 'accounts/:type',
									name: 'Accountst',
									component: CabinetAccounts,
									beforeEnter: requireAuth,
									props: true,
								},
								{
									path: 'platforms',
									name: 'Platforms',
									component: CabinetPlatforms,
									beforeEnter: requireAuth,
								},
								{
									path: 'history',
									name: 'History',
									component: CabinetHistory,
									beforeEnter: requireAuth,
								},
								{
									path: 'trading-tools',
									name: 'Trading-tools',
									component: CabinetTradingTools,
									beforeEnter: requireAuth,
								},
								{
									path: 'deposit',
									name: 'Deposit',
									component: CabinetDeposit,
									beforeEnter: requireAuth,
								},
								{
									path: 'transfer',
									name: 'Transfer',
									component: CabinetTransfer,
									beforeEnter: requireAuth,
								},
								{
									path: 'withdraw',
									name: 'Withdraw',
									component: CabinetWithdraw,
									beforeEnter: requireAuth,
								},
								{
									path: 'password',
									name: 'Password',
									component: CabinetPassword,
									beforeEnter: requireAuth,
								},
								{
									path: 'contact_us',
									name: 'Contact Us',
									component: CabinetContactUs,
									beforeEnter: requireAuth,
								},
								{
									path: 'success',
									name: 'Success',
									component: SuccessPage,
									beforeEnter: requireAuth,
								},
								{
									path: 'rejection',
									name: 'Rejection',
									component: RejectionPage,
									beforeEnter: requireAuth,
								},
								{
									path: 'progress',
									name: 'Progress',
									component: InfoPage,
									beforeEnter: requireAuth,
								},
								{
									path: 'application-process',
									name: 'ApplicationProcess',
									component: ApplicationProcess,
									beforeEnter: requireAuth,
								},
								{
									path: 'create_new_demo_account',
									name: 'New Demo Account',
									component: NewDemoAccount,
									beforeEnter: requireAuth,
								},
								{
									path: 'expired_documents/:type',
									name: 'Re-submit expired documents',
									component: CabinetExpiredDocuments,
									beforeEnter: requireAuth,
									props: true,
								},
							],
						},
					],
				},
				{
					path: ':pathMatch(.*)*',
					name: 'NotFound',
					component: () => import('../pages/NotFound.vue')
				}				  
			],
		},
	],
})

export default router
